import React from 'react';
import { Box } from 'modules/af_cm_ui_kit';
import fields, { FIELDS, INPUTS } from 'modules/cm/fields/types';

import { SectionProps } from './types';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { StoreReadonlyField } from 'modules/cm/fields/EditableField';

import styles from '../../subPages/Summary/Summary.module.scss';
import usePepperError from 'modules/cm/pages/CaseDetailsPage/hooks/useFieldError';
import UpdatableField from 'modules/cm/fields/UpdatableField';

const ApplicationSection: React.FC<SectionProps> = ({ modulePrefix, resources }) => {
  const { getErrors } = usePepperError('loanDetails');
  return (
    <Box title="Application">
      <StoreReadonlyField field={fields[FIELDS.CASE_ID]} />
      <StoreReadonlyField field={fields[FIELDS.APPLICATION_DATE]} variant={VARIANTS_TYPES.DATE} />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.SELECT}
        field={fields[FIELDS.APPLICATION_TYPE]}
        options={resources.applicationTypes}
        required
        getErrors={getErrors}
      />
      <StoreReadonlyField field={fields[FIELDS.NUMBER_OF_APPLICANTS]} />
      <label className={styles.bold}>Source of Deposit</label>
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.DEPOSIT_SOURCE_EQUITY_FROM_SALE]}
        variant="inline"
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.DEPOSIT_SOURCE_SAVINGS]}
        variant="inline"
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.DEPOSIT_SOURCE_GIFTS]}
        variant="inline"
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.DEPOSIT_SOURCE_BUILDERS]}
        variant="inline"
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.DEPOSIT_SOURCE_OTHER]}
        variant="inline"
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.TEXT}
        field={fields[FIELDS.DEPOSIT_SOURCE_DETAILS]}
        getErrors={getErrors}
      />
      <br />
      <label className={styles.bold}>Transaction Type</label>
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.IS_PRIVATE_SALE]}
        variant="inline"
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.IS_FIRST_TIME_BUYER]}
        variant="inline"
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.IS_BUY_TO_LET]}
        variant="inline"
        getErrors={getErrors}
      />

      <StoreReadonlyField field={fields[FIELDS.DEBT_TO_INCOME]} />
      <UpdatableField
        fieldType={INPUTS.SELECT}
        field={fields[FIELDS.HAS_ADVERSE_CREDIT]}
        options={[
          {
            option: 'Please select',
            value: '',
          },
          {
            option: 'Yes',
            value: 'true',
          },
          {
            option: 'No',
            value: 'false',
          },
        ]}
        required
        getErrors={getErrors}
      />
      <UpdatableField
        fieldType={INPUTS.SELECT}
        field={fields[FIELDS.IS_CREDIT_POLICY_EXEMPTION]}
        options={[
          {
            option: 'Yes',
            value: 'true',
          },
          {
            option: 'No',
            value: 'false',
          },
        ]}
        required
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.TEXTAREA}
        field={fields[FIELDS.CREDIT_POLICY_EXEMPTION_RATIONALE]}
        getErrors={getErrors}
      />
    </Box>
  );
};

export default ApplicationSection;
